// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-menu__content[data-v-4d07a4bc]{left:auto!important;right:20px!important}#userButton[data-v-4d07a4bc]{overflow:hidden}#userInitials[data-v-4d07a4bc]{position:absolute;color:#fff}.transparent[data-v-4d07a4bc]{opacity:.175}.noMenu[data-v-4d07a4bc]{pointer-events:none}.centerIcon[data-v-4d07a4bc]{-webkit-transform:translate(-60%);transform:translate(-60%)}.centerInitials[data-v-4d07a4bc]{top:5px;width:40px;margin-left:-32px}", ""]);
// Exports
module.exports = exports;
